<template>
  <teleport to="body">
    <transition :name="transition" @before-leave="onClose" @after-leave="$emit('destroy')">
      <div v-show="showDialog" class="SpDialog" :style="style">
        <span class="iconfont icon-close close-icon pointer" @click="close"></span>
        <p class="fs-bold title">{{ title }}</p>
        <p class="content fs-int">{{ content }}</p>
        <div class="footer">
          <SpButton circle type="cancleLight" :width="100" :height="42" @click="cancle">Cancle</SpButton>
          <SpButton circle type="confirm" :width="100" :height="42" @click="confirm">Confirm</SpButton>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script type="text/ecmascript-6">
import { ref, reactive, computed } from 'vue'
import SpButton from '@/components/common/SpButton'
import SpIcon from '../../SpIcon.vue'
import zIndexManager from '@/utils/zIndexManager'
export default {
  name: 'SpDialog',

  nameSpace: 'SpDialog',

  components: {
    SpButton,
    SpIcon
  },

  props: {
    type: {
      type: String,
      default: 'confirm'
    },

    width: {
      type: Number,
      default: 500
    },

    height: {
      type: Number,
      default: 200
    },

    title: {
      type: String,
      default: ''
    },

    content: {
      type: String,
      default: ''
    }
  },

  emits: ['destroy', 'close', 'cancle', 'confirm'],
  setup (props, ctx) {
    const showDialog = ref(true)
    const style = computed(() => {
      const style = {}
      style.width = `${props.width}px`
      style.height = props.height ? `${props.height}px` : 'auto'
      style.zIndex = zIndexManager.nextIndex()
      return style
    })

    const close = () => {
      showDialog.value = false
      ctx.emit('close')
    }
    const cancle = () => {
      showDialog.value = false
      ctx.emit('cancle')
    }
    const confirm = () => {
      showDialog.value = false
      ctx.emit('confirm')
    }
    return {
      showDialog,
      style,
      close,
      cancle,
      confirm
    }
  }

}
</script>

<style scoped lang="less">
.SpDialog{
  background-color: white;
  box-shadow: 0px 4px 27px 0px rgba(0, 0, 0, 0.25);
  padding:@gap;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  border-radius: 5px;
  .flex-al-bt();
  .close-icon{
    position: absolute;
    right: @gap;
    top: @gap;
  }
  .title{
    font-size: 20px;
    margin: 0;
  }
  .content{
    text-align: center;
  }
  .footer{
    // position: absolute;
    // bottom: @gap;
    // width: 100%;
    // box-sizing: border-box;
    .flex-jc-ard();
  }
}
</style>
